import { render, staticRenderFns } from "./CourseScore.vue?vue&type=template&id=183a1c94&scoped=true&"
import script from "./CourseScore.vue?vue&type=script&lang=js&"
export * from "./CourseScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a1c94",
  null
  
)

export default component.exports